/**
 * Format a numeric price into the short, slider-trigger-friendly form
 * `$X` (< 1000), `$Xk` (round thousand), `$X.Yk` (off-round thousand).
 *
 * Designed for $100-step values where the result is always at most 4-6 chars
 * — keeps the inline pill trigger from re-flowing as the user drags the
 * price slider. Off-step inputs round to one decimal `k`.
 *
 * Examples:
 *   abbreviatePrice(0)     → "$0"
 *   abbreviatePrice(900)   → "$900"
 *   abbreviatePrice(1000)  → "$1k"
 *   abbreviatePrice(1500)  → "$1.5k"
 *   abbreviatePrice(2700)  → "$2.7k"
 *   abbreviatePrice(10000) → "$10k"
 */
export function abbreviatePrice(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return '$0';
  if (value < 1000) return `$${Math.round(value)}`;
  const k = value / 1000;
  const display = k % 1 === 0 ? String(k) : k.toFixed(1).replace(/\.0$/, '');
  return `$${display}k`;
}
